import { Box } from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import CdrReadySidebarStepDisplay from "./CdrReadySidebarStepDisplay";

export default function CdrReadySidebar() {
  // -------------- This chunk of code is to give the step display a gradient that can handle the user zooming in -----------------
  const parentRef = useRef<HTMLDivElement>(null);
  const [blurPixelSize, setBlurPixelSize] = useState<number>(200);
  function handleResize() {
    if (parentRef.current) {
      const parentWidth = parentRef.current.offsetWidth;
      const calculatedBlur = parentWidth * 0.25;
      setBlurPixelSize(calculatedBlur);
    }
  }

  useEffect(() => {
    handleResize();

    window.addEventListener("resize", handleResize);

    // Clean up the event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // ---------------------------------------------------------------------------------------------------------------------------------

  return (
    <Box
      ref={parentRef}
      bg="#001229"
      ml={"20px"}
      borderRadius={"3xl"}
      position="relative"
      overflow="hidden"
      flex="5"
    >
      <Box
        position={"absolute"}
        width="55%"
        height="55%"
        left="-30%"
        top="65%"
        transform="translateY(-50%)"
        backgroundColor="#209181"
        borderRadius="50%"
        filter={`blur(${blurPixelSize}px)`}
        zIndex={1}
      />
      <Box
        position={"absolute"}
        width="55%"
        height="55%"
        right="-30%"
        top="35%"
        transform="translateY(-50%)"
        backgroundColor="#209181"
        borderRadius="50%"
        filter={`blur(${blurPixelSize}px)`}
        zIndex={1}
      />
      <Box zIndex={2} position={"absolute"}>
        <CdrReadySidebarStepDisplay />
      </Box>
    </Box>
  );
}
